import React from 'react';
import { View, Image } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { colorPropType } from '../../../Utils/PropTypesValidators';
import { Colors } from '../../Themes';
import { TypesList } from '../../Themes/Types';
import VFButton from '../../VFButton';
import VFText from '../../VFText';

import styles from './CardOverlay.Styles';
import CloseButton from './CloseButton/CloseButton';
import { getProperContainerMemoized, getProperPropsMemoized } from './VFOverlay.Types.Utils';

function CardOverlay({
  title,
  description,
  image,
  buttonTitle,
  closeIcon,
  onClosePress,
  onButtonPress,
  backgroundImage,
  backgroundColors,
  containerStyle,
  containerProps,
  imageProps,
  buttonDisabled,
  buttonStyle,
  buttonTextStyle,
  buttonType,
  ...props
}) {
  const ContainerComponent = getProperContainerMemoized(backgroundImage);
  const properContainerProps = getProperPropsMemoized(backgroundColors, backgroundImage);

  return (
    <ContainerComponent
      {...containerProps}
      {...properContainerProps}
      style={[styles.containerStyle, containerStyle]}
    >
      <CloseButton icon={closeIcon} onPress={onClosePress} />

      <View style={styles.containerStyle} />

      <View style={styles.cardContainerStyle}>
        <View style={styles.imageContainerStyle}>
          <Image {...imageProps} source={image} />
        </View>

        <View style={styles.textContainerStyle}>
          <VFText i18nKey={title} style={styles.titleTextStyle} />

          <VFText i18nKey={description} style={styles.descriptionTextStyle} />
        </View>

        <VFButton
          title={buttonTitle}
          onPress={onButtonPress}
          style={[styles.buttonStyle, buttonStyle]}
          textStyle={buttonTextStyle}
          disabled={buttonDisabled}
          type={buttonType}
        />
      </View>
    </ContainerComponent>
  );
}

CardOverlay.defaultProps = {
  backgroundColors: [Colors.transparent, Colors.transparent],
  containerProps: {},
  imageProps: {},
};

CardOverlay.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.shape({ uri: PropTypes.string }).isRequired,
  buttonTitle: PropTypes.string.isRequired,
  onClosePress: PropTypes.func.isRequired,
  onButtonPress: PropTypes.func.isRequired,
  closeIcon: PropTypes.shape({ uri: PropTypes.string }),
  backgroundImage: PropTypes.shape({ uri: PropTypes.string }),
  backgroundColors: PropTypes.arrayOf(colorPropType),
  containerStyle: ViewPropTypes.style,
  containerProps: PropTypes.object,
  imageProps: PropTypes.object,
  buttonDisabled: PropTypes.bool,
  buttonStyle: ViewPropTypes.style,
  buttonTextStyle: TextPropTypes.style,
  buttonType: PropTypes.oneOf(TypesList),
};

export default CardOverlay;
